import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useOrganization } from '../../contexts/OrganizationContext';
import Query from '../chat/Query';
import Results from '../chat/Results';
import { FaBuilding, FaPlus, FaCrown, FaUsers } from 'react-icons/fa';

export default function Dashboard() {
  const [queryResult, setQueryResult] = useState('');
  const { isMember, orgId, role, organizations, loading } = useOrganization();

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">AI Coaching Dashboard</h1>
      
      {/* Organization Status Widget */}
      {!loading && (
        <div className="mb-8">
          <div className="bg-white rounded-lg shadow-md p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center">
                <FaBuilding className="h-6 w-6 text-indigo-600 mr-3" />
                <h2 className="text-xl font-semibold text-gray-900">Organization Status</h2>
              </div>
              <Link
                to="/admin/organizations"
                className="text-indigo-600 hover:text-indigo-800 text-sm font-medium"
              >
                Manage
              </Link>
            </div>
            
            {isMember ? (
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="flex items-center">
                    <FaCrown className="h-4 w-4 text-yellow-500 mr-2" />
                    <span className="text-sm text-gray-600">
                      Role: <span className="font-medium capitalize">{role}</span>
                    </span>
                  </div>
                  <div className="flex items-center">
                    <FaUsers className="h-4 w-4 text-gray-500 mr-2" />
                    <span className="text-sm text-gray-600">
                      Organizations: <span className="font-medium">{organizations.length}</span>
                    </span>
                  </div>
                  {organizations.length > 1 && (
                    <div className="text-xs text-gray-500 mt-1">
                      Use the organization switcher in the top navigation to switch between organizations
                    </div>
                  )}
                </div>
                <div className="text-sm text-green-600 font-medium">
                  ✓ Active Organization Member
                </div>
              </div>
            ) : (
              <div className="flex items-center justify-between">
                <div className="text-gray-600">
                  You're not part of any organization yet.
                </div>
                <Link
                  to="/admin/organizations"
                  className="flex items-center px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  <FaPlus className="h-4 w-4 mr-2" />
                  Create Organization
                </Link>
              </div>
            )}
          </div>
        </div>
      )}
      
      <div className="grid gap-8">
        <Query setResult={setQueryResult} />
        {queryResult && <Results result={queryResult} />}
      </div>
    </div>
  );
}